import { RepairTaskDetailDto } from '@artemis-software/wr-api';
import { EnumTranslationPipe } from '@shared/pipes/enum-translation.pipe';
import { Pipe, PipeTransform } from '@angular/core';

const LABELS: Record<RepairTaskDetailDto.StatusEnum, string> = {
  DRAFT: 'Entwurf',
  TODO: 'Offen',
  IN_PROGRESS: 'In Bearbeitung',
  FINISHED: 'Abgeschlossen',
  DECLINED: 'Abgelehnt',
};

@Pipe({
  standalone: false,
  name: 'repairTaskStatusTranslation',
})
export class RepairTaskStatusTranslationPipe implements EnumTranslationPipe<RepairTaskDetailDto.StatusEnum | null | undefined>, PipeTransform {
  transform(value: RepairTaskDetailDto.StatusEnum | null | undefined): string {
    if (!value) {
      return '–';
    }
    const label = LABELS[value];
    if (!label) {
      console.error(`Unknown status: ${value}`);
      return '–';
    }
    return label;
  }
}
